module.exports = __webpack_public_path__ + "img/vertical.522f5dd2.svg";